import React, { Component } from "react";
//import ChartistGraph from "react-chartist";
import { Grid as Container, Row, Col } from "react-bootstrap";
import TimeAgo from "timeago-react"; // var TimeAgo = require('timeago-react');
//import timeago from "timeago.js";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import { getAlarmSeverity } from "utils/alarmPresentation";
//timeago.register("pl_PL", require("timeago.js/locales.js"));

//import { Card } from "components/Card/Card.jsx";

//import { Tasks } from "components/Tasks/Tasks.jsx";

class Dashboard2 extends Component {
  state = {
    alarms: []
  };

  componentDidMount() {
    this.mounted = true;
    this.loadAlarms();
    this.alarmTimer = window.setInterval(this.loadAlarms, 30000);
  }

  componentDidUpdate(previousProps) {
    if (previousProps.credentials !== this.props.credentials)
      this.loadAlarms();
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.alarmTimer) window.clearInterval(this.alarmTimer);
  }

  loadAlarms = () => {
    if (!this.props.credentials) return;
    fetch("https://hgsystem.pl/mangusta/alarms.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        auth: this.props.credentials,
        action: "list",
        status: "active",
        limit: 500,
        offset: 0
      })
    })
      .then(response =>
        response.json().then(data => {
          if (!response.ok)
            throw new Error(data.error || "Nie udało się pobrać alarmów.");
          if (this.mounted)
            this.setState({ alarms: Array.isArray(data.alarms) ? data.alarms : [] });
        })
      )
      .catch(() => {});
  };

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  getDeviceData = id => {
    const measurements =
      (this.props.lastMeasurement && this.props.lastMeasurement[id]) || [];
    const level = measurements.find(
      measurement => Number(measurement.input_id) === 1
    );
    const temperature = measurements.find(
      measurement => Number(measurement.input_id) === 2
    );

    return [
      this.formatMeasurement(level, " l"),
      this.formatMeasurement(temperature, "°C")
    ];
  };

  formatMeasurement = (measurement, unit) => {
    if (!measurement || measurement.value === undefined)
      return `— ${unit.trim()}`;

    const value = Number(measurement.value);
    return isFinite(value) ? `${value.toFixed(2)} ${unit.trim()}` : `— ${unit.trim()}`;
  };

  getLastMeasurementTime = id => {
    const measurements =
      (this.props.lastMeasurement && this.props.lastMeasurement[id]) || [];
    const timestamps = measurements
      .map(measurement => Number(measurement.timestamp))
      .filter(timestamp => isFinite(timestamp) && timestamp > 0);

    if (timestamps.length === 0) return "Brak pomiarów";
    return (
      <TimeAgo
        datetime={Math.max(...timestamps) * 1000}
        locale="pl_PL"
      />
    );
  };

  openDeviceChart = deviceId => {
    this.props.history.push(
      `/charts?device=${encodeURIComponent(String(deviceId))}`
    );
  };

  openDeviceAlarms = deviceId => {
    this.props.history.push(
      `/alarms?device=${encodeURIComponent(String(deviceId))}`
    );
  };

  alarmsForDevice = deviceId =>
    this.state.alarms
      .filter(alarm => String(alarm.device_id) === String(deviceId))
      .sort(
        (left, right) =>
          Number(right.severity) - Number(left.severity) ||
          Number(right.raised_at) - Number(left.raised_at) ||
          Number(right.id) - Number(left.id)
      );

  tileAlarm = deviceId => {
    const alarms = this.alarmsForDevice(deviceId);
    if (alarms.length === 0) return null;
    const alarm = alarms[0];
    const severity = getAlarmSeverity(alarm.severity);
    return {
      color: severity.color,
      label: severity.label,
      message:
        alarm.message ||
        alarm.title ||
        `Alarm urządzenia, kod ${alarm.alarm_code}`,
      time: (
        <TimeAgo
          datetime={Number(alarm.raised_at) * 1000}
          locale="pl_PL"
        />
      ),
      additionalCount: alarms.length - 1
    };
  };

  render() {
    const devices = Array.isArray(this.props.device) ? this.props.device : [];
    return (
      <div className="content">
        <Container fluid>
          <Row>
            {devices.map(device => {
              return (
                <Col lg={4} sm={6} key={device.id}>
                  <StatsCard
                    bigIcon={<i className="pe-7s-info text-primary" />}
                    statsText={device.desc || device.id}
                    statsValue={this.getDeviceData(device.id)}
                    statsIcon={<i className="fa clock" />}
                    statsIconText={this.getLastMeasurementTime(device.id)}
                    alarm={this.tileAlarm(device.id)}
                    onAlarmClick={() => this.openDeviceAlarms(device.id)}
                    onClick={() => this.openDeviceChart(device.id)}
                    title={`Pokaż wykres urządzenia ${device.desc || device.id}`}
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    );
  }
}

export default Dashboard2;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard2.jsx